import React, { useContext, useEffect } from "react";

import { useRouteMatch } from "react-router-dom";

import { FavoritesMenuItems } from "@features/offer/desktop/offer-menu/components/favorites-menu-items";
import { OfferStoreContext } from "@gp/components";
import { useRootAppStore } from "@hooks";
import { Period } from "@state/common/PeriodConverter";
import { FavoritesStoreContext } from "@state/context/favorites/FavoritesStoreContext";
import PrematchOfferMenuStore from "@state/stores/offer/prematch/PrematchOfferMenuStore";
import { observer } from "mobx-react";

import { ExpandedOfferMenu, ExpandedPeriodMenu, MainMenu } from "./components";

export const PrematchOfferMenu = observer(function PrematchOfferMenu(props: {
	prematchOfferMenuStore: PrematchOfferMenuStore;
}) {
	const match = useRouteMatch<{ period: Period; segments: string }>();
	const favoritesStore = useContext(FavoritesStoreContext);
	const rootStore = useRootAppStore();

	useEffect(() => {
		props.prematchOfferMenuStore.periodSubMenu.onInitialize(
			match.params.period
		);
		props.prematchOfferMenuStore.onInitialize();
		return () => props.prematchOfferMenuStore.onDispose();
	}, []);

	useEffect(() => {
		props.prematchOfferMenuStore.setRouterMatchObj(match);
		if (favoritesStore.period != match.params.period) {
			favoritesStore.setPeriod(match.params.period);
		}
	}, [match]);

	useEffect(() => {
		rootStore.quickPlayStore.quickBetStore.initializeMenuStore(
			props.prematchOfferMenuStore
		);

		return () => {
			rootStore.quickPlayStore.quickBetStore.removeMenuStore();
		};
	}, []);

	return (
		// @ts-expect-error
		<OfferStoreContext.Provider value={props.prematchOfferMenuStore}>
			<MainMenu store={props.prematchOfferMenuStore} />
			<ExpandedMenuWrapper store={props.prematchOfferMenuStore} />
		</OfferStoreContext.Provider>
	);
});

const ExpandedMenuWrapper = observer(function ExpandedMenuWrapper(props: {
	store: {
		isOfferMenuOpen: boolean;
		toggleUpdateProcessing: PrematchOfferMenuStore["toggleUpdateProcessing"];
		periodSubMenu: {
			isPeriodMenuExpanded: boolean;
			setPeriodKey: (p: Period) => void;
			periodMenu: { period: Period; name: string }[];
			selectedPeriodKey: Period;
			previousPeriodMenu: { period: string; name: string }[];
		};
		isEmpty: boolean;
		isLoading: boolean;
		selectedSport: PrematchOfferMenuStore["selectedSport"];
		menu: PrematchOfferMenuStore["menu"];
		isFavoritesSubMenuOpen: boolean;
	};
}) {
	if (props.store.isOfferMenuOpen) {
		//@ts-expect-error
		return <ExpandedOfferMenu store={props.store} />;
	}

	if (props.store.periodSubMenu.isPeriodMenuExpanded) {
		return <ExpandedPeriodMenu store={props.store} />;
	}
	if (props.store.isFavoritesSubMenuOpen) {
		return <FavoritesMenuItems store={props.store} />;
	}

	return null;
});
